<div class="layout-column">

  <app-bringoz-select [options]="countries"
                      [selectedValue]="countryCode"
                      [bindValue]="'code'"
                      [placeholder]="'Code'"
                      (onValueChange)="onChange.emit($event)">
    <ng-template #ngLabelTmp let-selected>
      <span class="fi {{ countryCode ? 'fi-' + countryCode.toLowerCase() : '' }}"></span>
    </ng-template>

    <ng-template #ngOptionTmp let-item>
      <span class="fi {{ item?.code ? 'fi-' + item?.code.toLowerCase() : '' }}"></span>
      <span class="br-body-2">{{ item?.dial_code }}</span>
    </ng-template>

  </app-bringoz-select>

  <div class="layout-row layout-align-start-center text-ellipsis">
    <span *ngIf="siteCountryCode !== countryCode"
          class="br-body-1 foreign-number"
          [ngbTooltip]="tooltip"
          openDelay="300"
          triggers="hover"
          container="body">
      {{'FOREIGN_NUMBER_ALERT' | translate}}
    </span>
  </div>

  <ng-template #tooltip>
    <span>{{'FOREIGN_NUMBER_ALERT_TOOLTIP' | translate}}</span>
  </ng-template>

</div>
